import { AlertType } from 'root/apps/components/AlertMessageDisplay/AlertMessageDisplay';

export interface InventoryCountImportError extends Error {
  type: AlertType;
  title?: string;
}

export interface InventoryCountImportErrorOptions {
  type?: AlertType;
  title?: string;
}
export class InventoryCountImportError extends Error implements InventoryCountImportError {
  constructor(message: string, options: InventoryCountImportErrorOptions = {}) {
    super(message);
    this.name = 'InventoryCountImportError';
    this.title = options.title;
    this.type = options.type || 'danger';
  }
}
